'use strict';

angular.module('docketbook')
.controller('companySettingsFieldsController', function($scope, docketService, Restangular, $state, $window, $stateParams, accessControl, $q) {
  mixpanel.track("Opened CompanySettings-Fields Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.editField = {};
  $scope.selected = [];
  $scope.query = {
    limit: 10,
    page: 1,
    sort: 'displayName'
  };
  $scope.listCount = 0;

  $scope.goTo = function(href) {
    $window.location.href = href;
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /************************/
  /**** List Controls *****/
  /************************/

  $scope.loadFieldsList = function() {
    $scope.promise = $q(function(resolve, reject) {
      // Get templates from docketService
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      docketService.getFields(queryParams, function(fields) {
        $scope.allFields = fields;
        if ( queryParams.offset <= 0 && fields.length < queryParams.limit ) {
          $scope.listCount = fields.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function(error) {
        $scope.allFields = [];
        reject('Error');
      });
    });
  }

  $scope.loadFieldsList();

  /***************************************/
  /***** Docket Fields Functionality *****/
  /***************************************/

  $scope.openNewFieldModal = function() {
    $scope.newFieldFromParent({}, function(newField) {
      if ( newField != null ) {
        docketService.saveField(newField, function() {
          $scope.loadFieldsList();
        }, function(err) {
          field.loading = false;
          $scope.alertService.presentAutoAlert('saveField', err);
        });
      }
    });
  }

  $scope.editField = function(field) {
    $scope.editFieldFromParent(field, function(fieldEdited, templatesNeedUpdating, onTemplates) {
      if ( fieldEdited != null ) {
        docketService.saveField(fieldEdited, function() {
          $scope.loadFieldsList();
          if ( templatesNeedUpdating ) {
            updateTemplatesWithFieldChange(field, onTemplates);
          }
        }, function(err) {
          field.loading = false;
          $scope.alertService.presentAutoAlert('saveField', err);
        });
      }
    });
  }


  $scope.deleteSelectedFields = function() {
    var count = $scope.selected.length;
    swal({
			title: "Are you sure?",
			text: count + " fields will be deleted.",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
        docketService.deleteBulkFields($scope.selected, function(failures) {
          if ( failures && failures.length > 0 ) {
            $scope.alertService.presentAutoAlert('deleteBulkFields', {status:202, requestName: 'Delete bulk field - failures ' + failures.length + ' of ' + $scope.selected.length});
            $scope.loadFieldsList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkFields',{status:200});
            $scope.loadFieldsList();
          }
        });
			}
		});
  }

  var updateTemplatesWithFieldChange = function(field, templates) {
    for ( var i = 0; i < templates.length; i++ ) {
      docketService.getTemplate(templates[i], function(templateFull) {
        // find interaction templates with this field in it
        for ( var j = 0; j < templateFull.interactionTemplates.length; j++ ) {
          var thisInteraction = templateFull.interactionTemplates[j];
          for ( var k = 0; k < thisInteraction.fields.length; k++ ) {
            if ( thisInteraction.fields[k].id == field.id ) {
              // this field needs updating
              thisInteraction.fields[k].displayName = field.displayName;
              thisInteraction.fields[k].mandatory = field.mandatory;
              if ( field.type == 'select' ) {
                thisInteraction.fields[k].selectionFields = field.selectionFields;
              }
            }
          }
        }
        // save this template
        docketService.saveTemplate(templateFull, function(templateSaved) {
        }, function(err) {
        });
      }, function(err) {
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/controllers/companySettings/fields.js